<template>
  <v-container fluid style="background-color: var(--v-background-base);" class="pa-10">
    <DlgConfirmCancel ref="confirm"></DlgConfirmCancel>
    <v-form ref="calculateForm">
     <JuridicalPersonDataKit 
       id="juridicalPersonData" 
       v-if="quoteData" 
       :quoteData="quoteData"
       @resetValidationFields="resetValidationFields">
     </JuridicalPersonDataKit>
     <PlansSliderSwitch 
       class="pt-5" v-if="quoteData" 
       :quoteData="quoteData" 
       :selectedJuridicalPerson="selectedJuridicalPerson"
       @saveBenefitsToSend="saveBenefitsToSend">
     </PlansSliderSwitch>
    
     <v-row>
       <v-col cols="12">
         <v-card>
           <v-card-actions class="d-block d-sm-block d-md-block d-lg-block text-right">
             <v-spacer></v-spacer>
             <v-btn
               @click="() => $router.back()"
               class="btn-quote mt-1 ml-0 mr-2"
               large
               :width="buttonWidth">
               <v-icon left>fas fa-arrow-left</v-icon>
               Voltar
             </v-btn>
             <v-btn
               :disabled="!benefitsToSend || !benefitsToSend.length"
               @click="onClickSendResume()"
               class="btn-quote mt-1 ml-0 mr-2"
               large
               :width="buttonWidth">
               <v-icon left>fas fa-file-invoice-dollar</v-icon>
               Enviar Resumo Financeiro
             </v-btn>
             <v-btn
               :disabled="!benefitsToSend || !benefitsToSend.length"
               @click="onClickSendKit()"
               class="btn-quote mt-1 ml-0 mr-2"
               large
               :width="buttonWidth">
               <v-icon left>fas fa-file-alt</v-icon>
               Enviar Kit
             </v-btn>
           </v-card-actions>
         </v-card>
       </v-col>
     </v-row>
   </v-form>
  </v-container>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";
import JuridicalPersonDataKit from "@/components/quote-form/juridicalPersonDataKit.vue";
import PlansSliderSwitch from "@/components/quote-form/plansSliderSwitch.vue";
import QuoteService from "@/services/odoo/QuoteService";
import DlgConfirmCancel from "@/components/dlg-confirm_cancel.vue";
export default {
  name: 'calculateQuote',
  components: {
    DlgConfirmCancel,
    JuridicalPersonDataKit,
    PlansSliderSwitch,
  },
  data: () => ({
    id: null,
    benefitsToSend: [],
    buttonWidth: 250,
    quoteData: null,
    selectedJuridicalPerson: null,
    benefitTemp: null
  }),
  methods: {
    ...mapMutations(['showmsg', 'setDialogLoading']),
    ...mapActions(['setQuoteId']),
    saveBenefitsToSend(benefits) {
      if(benefits && benefits.length) {
        this.benefitsToSend = this.filterBenefitCarrierByPlansSelecteds(benefits);
      }
    },
    filterBenefitCarrierByPlansSelecteds(benefits) {
      
      return benefits.map(benefit => {
        if(benefit) {
          const carriersFiltered = benefit.carriers.filter(carrier => carrier.enabled).map(carrier => {
            const planClassificationsMaped = carrier.planClassifications.map(planClassification => {
              if(planClassification && planClassification.plans.some(plan => plan.selected)) {
                return {
                  ...planClassification,
                  plans: planClassification.plans.filter(plan => plan.selected)
                }
              } else {
                return null;
              }

            }).filter(planClassification => planClassification)

            if(carrier && planClassificationsMaped.length) {
              return {
                ...carrier,
                planClassifications: planClassificationsMaped,
              }
            } else {
              return null;
            }
          }).filter(carrier => carrier);

          if(carriersFiltered.filter(carrier => carrier).length) {
            return {
              ...benefit,
              carriers: carriersFiltered,
            }
          } else {
            return null;
          }
        }
        return null;

      }).filter(benefit => benefit);
    },
    validateJuridicalPersonType() {
      this.selectedJuridicalPerson = this.$route.query.type;
      if(!this.selectedJuridicalPerson || (this.selectedJuridicalPerson.trim() !== 'PJ' && this.selectedJuridicalPerson.trim() !== 'PJ_PLAN')) {
        this.$router.back();
      }
    },
    validateQuoteData() {
      const key = 'quoteDataObj';
      
      if(sessionStorage.getItem(key)) {
        this.quoteData = JSON.parse(atob(sessionStorage.getItem(key)));
      } else {
        this.$router.back();
      }
    },
    createQuoteDTO() {
      const type = this.selectedJuridicalPerson;
      
      let lead = null;
      if(this.quoteData && this.quoteData.juridicalPersonObj) {
        lead = {
          id: this.quoteData.juridicalPersonObj.id ? this.quoteData.juridicalPersonObj.id : null,
          cnpj: this.quoteData.juridicalPersonObj.cnpj ? this.$util.removeMask(this.quoteData.juridicalPersonObj.cnpj) : null,
          commercialName: this.quoteData.juridicalPersonObj.legalName,
          city: {
            id: this.quoteData.juridicalPersonObj.city ? this.quoteData.juridicalPersonObj.city.id : null,
            name: this.quoteData.juridicalPersonObj.city ? this.quoteData.juridicalPersonObj.city.name : null,
            state: {
              id: this.quoteData.juridicalPersonObj.city && this.quoteData.juridicalPersonObj.city.state_id
                ? this.quoteData.juridicalPersonObj.city.state_id.id : null,
              name: this.quoteData.juridicalPersonObj.city && this.quoteData.juridicalPersonObj.city.state_id
                ? this.quoteData.juridicalPersonObj.city.state_id.name : null,
              code: this.quoteData.juridicalPersonObj.city && this.quoteData.juridicalPersonObj.city.state_id
                ? this.quoteData.juridicalPersonObj.city.state_id.code : null,
            }
          },
          contact: {
            name: this.quoteData.juridicalPersonObj.nameContact,
            mobilePhone: this.quoteData.juridicalPersonObj.phoneContact ? this.$util.removeMask(this.quoteData.juridicalPersonObj.phoneContact) : null,
            email: this.quoteData.juridicalPersonObj.emailContact,
            emailCC: this.quoteData.juridicalPersonObj.emailWithCopy
          },
          street: this.juridicalPersonKitObj ? this.juridicalPersonKitObj.address : null,
          zip: this.juridicalPersonKitObj && this.juridicalPersonKitObj.addressZip ? this.$util.removeMask(this.juridicalPersonKitObj.addressZip) : null,
          district: this.juridicalPersonKitObj ? this.juridicalPersonKitObj.addressNeighborhood : null,
          streetNumber: this.juridicalPersonKitObj ? this.juridicalPersonKitObj.addressNumber : null,
          complement: this.juridicalPersonKitObj ? this.juridicalPersonKitObj.addressComplement : null,
          effectiveDate: this.juridicalPersonKitObj ? this.juridicalPersonKitObj.effectiveDate : null,
        }
      }

      let contractFeatures = null;

      if(this.quoteData && this.quoteData.planFiltersObj) {
        contractFeatures = {
          allEmployees: this.quoteData.planFiltersObj.allEmployees && this.quoteData.planFiltersObj.allEmployees.length
            ? this.quoteData.planFiltersObj.allEmployees[0] : null,
          withCopay: this.quoteData.planFiltersObj.allEmployees && this.quoteData.planFiltersObj.hasCopay.length
            ? this.quoteData.planFiltersObj.hasCopay[0] : null,
          classification: this.quoteData.planFiltersObj.planClassifications && this.quoteData.planFiltersObj.planClassifications.length
            ? this.quoteData.planFiltersObj.planClassifications.map(item => {
              return {
                id: parseInt(item),
                name: null
              }
            }) : null,
          accommodation: this.quoteData.planFiltersObj.geographicScopes && this.quoteData.planFiltersObj.accommodations.length
            ? this.quoteData.planFiltersObj.accommodations.map(item => {
              return {
                code: item,
                description: null,
              }
            }) : null,
          geographicScope: this.quoteData.planFiltersObj.geographicScopes && this.quoteData.planFiltersObj.geographicScopes.length
            ? this.quoteData.planFiltersObj.geographicScopes.map(item => {
              return {
                name: item
              }
            }) : null,
          hospitalProviders: this.quoteData.planFiltersObj.hospitalsObj && this.quoteData.planFiltersObj.hospitalsObj.length
            ? this.quoteData.planFiltersObj.hospitalsObj.map(item => {
              return {
                id: item,
                description: null
              }
            }) : null,
          laboratoryProviders: this.quoteData.planFiltersObj.hospitalsObj && this.quoteData.planFiltersObj.laboratoriesObj.length
            ? this.quoteData.planFiltersObj.laboratoriesObj.map(item => {
              return {
                id: item,
                description: null
              }
            }) : null,
        }
      }

      let ageRange = null;
      let benefit = [];
      if(this.selectedJuridicalPerson === 'PJ') {
        if(this.quoteData && this.quoteData.ageIntervalsObj.length) {
          ageRange = this.quoteData.ageIntervalsObj;
          ageRange.forEach((age, indexAge) => {
            if(indexAge < ageRange.length - 1) {
              age.beneficiariesFiftyNinePlus = null
            } else {
              age.beneficiariesFiftyNinePlus = this.quoteData.enumeratedAgesObj
            }
          })
        }

        if (this.quoteData && this.quoteData.benefitsObj) {
          benefit = this.benefitsToSend.map(benefitItem => {
            return {
              id: benefitItem.id,
              code: benefitItem.code,
              name: benefitItem.name,
              carriers: benefitItem.carriers.map(carrierItem => {
                let selectedPlans = [];
                if (carrierItem.planClassifications && carrierItem.planClassifications.length) {
                  carrierItem.planClassifications.forEach(planClassification => {
                    if (planClassification.plans && planClassification.plans.length) {
                      selectedPlans = selectedPlans.concat(planClassification.plans)
                    }
                  })
                }

                if (selectedPlans.length) {
                  selectedPlans = selectedPlans.map(plan => {
                    return {
                      id: plan.id,
                      description: plan.description,
                      name: plan.name,
                      integrator: plan.integrator
                    }
                  })
                }

                return {
                  id: carrierItem.id,
                  comercialName: carrierItem.comercialName,
                  directoryKit: carrierItem.directoryKit,
                  name: carrierItem.name,
                  image: carrierItem.image,
                  isReference: carrierItem.isReference,
                  selectedPlans,
                  planClassifications: carrierItem.planClassifications
                }
              })
            }
          })
        }
      } else if(this.selectedJuridicalPerson === 'PJ_PLAN') {

        if(this.quoteData && this.quoteData.ageIntervalsObj.length) {
          ageRange = this.quoteData.ageIntervalsObj;
        }

        if (this.quoteData && this.quoteData.plansGroupByBenefitCarrierObj && this.quoteData.plansGroupByBenefitCarrierObj.length) {
          
          let planIds = this.benefitsToSend.flatMap(benefit => 
            benefit.carriers.flatMap(carrier => 
              carrier.planClassifications.flatMap(planClassification => 
                planClassification.plans.map(plan => plan.id)
              )
            )
          );

          const filteredPlansGroupByBenefitCarrierObj = this.quoteData.plansGroupByBenefitCarrierObj.filter(carrier =>
            carrier.plans.some(plan => planIds.includes(plan.id))
          );

          filteredPlansGroupByBenefitCarrierObj.forEach(benefitCarrier => {
            const benefitFound = benefit.find(benefit => benefit.id === benefitCarrier.benefitId);

            if(benefitFound) {
              const indexOfBenefit = benefit.indexOf(benefitFound);

              if(indexOfBenefit >= 0) {
                const carrierFound = benefit[indexOfBenefit].carriers.find(carrier => carrier.id === benefitCarrier.carrierId);

                if(carrierFound) {
                  const indexOfCarrier = benefit[indexOfBenefit].carriers.indexOf(carrierFound);
                  if(indexOfCarrier >= 0) {
                    benefit[indexOfBenefit].carriers[indexOfCarrier].selectedPlans = benefitCarrier.plans.map(plan => {
                      const ageIntervals = plan.ageIntervals;

                      if(plan.enumeratedAges && plan.enumeratedAges.length) {
                        ageIntervals[ageIntervals.length - 1].beneficiariesFiftyNinePlus = plan.enumeratedAges;
                      }

                      let planClassificationFound = this.quoteData.benefit[indexOfBenefit].carriers[indexOfCarrier].planClassification
                        .filter(pc => pc.plans.some(p => p.id==plan.id && p.integrator))

                      return {
                        id: plan.id,
                        description: plan.description,
                        name: plan.name,
                        ageRange: ageIntervals,
                        integrator: planClassificationFound && planClassificationFound.length > 0
                      }
                    })
                  }

                } else {
                  let planClassifications = [];
                  const benefitFound = this.benefitsToSend.find(benefit => benefit.id === benefitCarrier.benefitId);
                  if(benefitFound) {
                    const indexOfBenefit = this.benefitsToSend.indexOf(benefitFound);
                    if(indexOfBenefit >= 0) {
                      const carrierFound = this.benefitsToSend[indexOfBenefit].carriers.find(carrier => carrier.id === benefitCarrier.carrierId);
                      if(carrierFound) {
                        planClassifications = carrierFound.planClassifications;
                      }
                    }
                  }

                  const carrier = {
                    id: benefitCarrier.carrierId,
                    comercialName: benefitCarrier.carrierComercialName,
                    name: benefitCarrier.carrierName,
                    directoryKit: benefitCarrier.carrierDirectoryKit,
                    image: benefitCarrier.carrierImage,
                    isReference: benefitCarrier.carrierIsReference,
                    planClassifications: planClassifications,
                    selectedPlans: benefitCarrier.plans.map(plan => {
                      const ageIntervals = plan.ageIntervals;

                      if(plan.enumeratedAges && plan.enumeratedAges.length) {
                        for(let i = 0; i <= 8; i++) {
                          ageIntervals[i].beneficiariesFiftyNinePlus = null;
                        }
                        ageIntervals[ageIntervals.length - 1].beneficiariesFiftyNinePlus = plan.enumeratedAges;
                      }

                      let planClassificationFound = planClassifications
                        .filter(pc => pc.plans.some(p => p.id==plan.id && p.integrator))

                      return {
                        id: plan.id,
                        description: plan.description,
                        name: plan.name,
                        ageRange: ageIntervals,
                        integrator: planClassificationFound && planClassificationFound.length > 0
                      }
                    })
                  }

                  benefit[indexOfBenefit].carriers.push(carrier);
                }
              }

            } else {
              let planClassifications = [];
              const benefitFound = this.benefitsToSend.find(benefit => benefit.id === benefitCarrier.benefitId);
              if(benefitFound) {
                const indexOfBenefit = this.benefitsToSend.indexOf(benefitFound);
                if(indexOfBenefit >= 0) {
                  const carrierFound = this.benefitsToSend[indexOfBenefit].carriers.find(carrier => carrier.id === benefitCarrier.carrierId);
                  if(carrierFound) {
                    planClassifications = carrierFound.planClassifications;
                  }
                }
              }

              const carrier = {
                id: benefitCarrier.carrierId,
                comercialName: benefitCarrier.carrierComercialName,
                name: benefitCarrier.carrierName,
                directoryKit: benefitCarrier.carrierDirectoryKit,
                image: benefitCarrier.carrierImage,
                isReference: benefitCarrier.carrierIsReference,
                planClassifications: planClassifications,
                selectedPlans: benefitCarrier.plans.map(plan => {
                  const ageIntervals = plan.ageIntervals;

                  if(plan.enumeratedAges && plan.enumeratedAges.length) {
                    for(let i = 0; i <= 8; i++) {
                      ageIntervals[i].beneficiariesFiftyNinePlus = null;
                    }
                    ageIntervals[ageIntervals.length - 1].beneficiariesFiftyNinePlus = plan.enumeratedAges;
                  }

                  let planClassificationFound = planClassifications
                        .filter(pc => pc.plans.some(p => p.id==plan.id && p.integrator))

                  return {
                    id: plan.id,
                    description: plan.description,
                    name: plan.name,
                    ageRange: ageIntervals,
                    integrator: planClassificationFound && planClassificationFound.length > 0
                  }
                })
              }

              benefit.push({
                id: benefitCarrier.benefitId,
                code: benefitCarrier.benefitCode,
                name: benefitCarrier.benefitName,
                carriers: [carrier]
              });
            }
          })
        }
      }

      let studyConfigurationId = null;
      if(this.quoteData && this.quoteData.projectObj ) {
        studyConfigurationId = this.quoteData.projectObj.id;
      }

      //send others benefits not selecteds to reload in edit option
      if (this.quoteData && this.quoteData.benefitsObj) {
        this.quoteData.benefitsObj.forEach(benefitItem => {
          benefitItem.carriers.forEach(carrierItem => {
            const benefitFound = benefit.find(item => item.id === benefitItem.id);
            if(benefitFound) {
              const indexOfBenefit = benefit.indexOf(benefitFound);
              if(indexOfBenefit >= 0){
                const carrierFound = benefit[indexOfBenefit].carriers.find(item => item.id === carrierItem.id);
                if(carrierFound) {
                  const indexOfCarrier = benefit[indexOfBenefit].carriers.indexOf(carrierFound);
                  benefit[indexOfBenefit].carriers[indexOfCarrier].planClassifications = carrierItem.planClassifications;
                } else {
                  carrierItem.selectedPlans = [];
                  benefit[indexOfBenefit].carriers.push(JSON.parse(JSON.stringify(carrierItem)));
                }
              }
            } else {
              benefitItem.carriers.forEach(carrier => {
                carrier.selectedPlans = [];
              });

              benefit.push(JSON.parse(JSON.stringify(benefitItem)));
            }
          })
        })
      }
      //end

      const id = this.quoteData && this.quoteData.quoteId ? this.quoteData.quoteId : this.id;
      const parentQuoteId = this.quoteData ? this.quoteData.parentQuoteId : null;
      
      const payload = {
        id,
        parentQuoteId,
        type,
        lead,
        contractFeatures,
        ageRange,
        benefit,
        studyConfigurationId
      }
      
      return payload;
    },
    resetValidationFields() {
      this.$refs.calculateForm.resetValidation();
    },
    async onClickSendKit() {
      if(!this.$refs.calculateForm.validate()) {
        this.scrollToElementById('juridicalPersonData');
        return;
      }
      
      const quoteDTO = this.createQuoteDTO();
      let benefitsSelected = quoteDTO.benefit.filter(b => b.carriers.some(c => c.selectedPlans.length>0));
      let benefitsIntegradora = quoteDTO.benefit.filter(b => b.carriers.some(c => c.selectedPlans.some(p => p.integrator)));
      if(benefitsIntegradora.length == 0){
        this.showmsg({text: 'O(s) plano(s) selecionado(s) não possuem tabela de preço da integradora.', type: 'warning'});
        return;
      }else if(benefitsIntegradora.length != benefitsSelected.length){
        let planNamesOutsideIntegrator = [];
          quoteDTO.benefit.forEach(b =>{
            b.carriers.forEach(c => {
              c.selectedPlans.filter(p => !p.integrator).forEach(p => {
                planNamesOutsideIntegrator.push(p.name);
              });
            });
          });
        if(planNamesOutsideIntegrator.length>0) {
          if (await this.$refs.confirm.show("Atenção", "O(s) plano(s) selecionado(s) " + planNamesOutsideIntegrator.toString() + " não possuem tabela de preço da integradora e não será enviado kit. Deseja continuar o envio dos demais planos?")) {
            await this.sendKit(quoteDTO);
          }
        }
      } else {
        await this.sendKit(quoteDTO);
      }
      
      
    },
    async sendKit(quoteDTO){
      this.setDialogLoading(true);
      if(quoteDTO) {
        quoteDTO.sendKit = true;
        await this._quoteService.save(quoteDTO)
          .then((response) => {
            if(response && response.data) {
              this.id = response.data;
              this.setQuoteId(response.data);
              this.showmsg({text: 'Um e-mail foi enviado contendo o Kit em anexo.', type: 'success'});
            }
          })
          .catch((error) => {
            if(error && error.response && error.response.status === 400) {
              this.showmsg({text: error.response.data.message, type: 'error'})
            } else {
              this.showmsg({text: 'Ocorreu um erro ao tentar enviar o Kit.', type: 'error'});
            }
          })
          .finally(() => {
            this.setDialogLoading(false);
          });
      } else {
        this.setDialogLoading(false);
        this.showmsg({text: 'As informações necessárias para o envio do Kit não foram carregadas.', type: 'error'});
      }
    },
    async onClickSendResume() {
      if (!this.$refs.calculateForm.validate()) {
        this.scrollToElementById('juridicalPersonData');
        return;
      }

      this.setDialogLoading(true);
      const quoteDTO = this.createQuoteDTO();
      if(quoteDTO) {
        quoteDTO.sendFinancialResume = true;
        await this._quoteService.save(quoteDTO)
          .then((response) => {
            if(response && response.data) {
              this.id = response.data;
              this.setQuoteId(response.data);
              this.showmsg({text: 'Um e-mail foi enviado contendo o Resumo Financeiro em anexo.', type: 'success'});
            }
          })
          .catch((error) => {
            if(error && error.response && error.response.status === 400) {
              this.showmsg({text: error.response.data.message, type: 'error'})
            } else {
              this.showmsg({text: 'Ocorreu um erro ao tentar enviar o Resumo Financeiro.', type: 'error'});
            }
          })
          .finally(() => {
            this.setDialogLoading(false);
          });
      }else {
        this.setDialogLoading(false);
        this.showmsg({text: 'As informações necessárias para o envio do Resumo Financeiro não foram carregadas.', type: 'error'});
      }
    },
    scrollToElementById(id) {
      if(id) {
        setTimeout(() => {
          const element = document.getElementById(id);
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 250);
      }
    },
  },
  computed: {
    ...mapGetters(['juridicalPersonKitObj']),
  },
  beforeCreate() {
    this._quoteService = new QuoteService();
  },
  created() {
    this.validateJuridicalPersonType();
    this.validateQuoteData();
  },
};
</script>

<style scoped>
</style>
